module.exports = __webpack_public_path__ + "c26f38651683b816e290afe5251cc63d.svg";